import React from 'react';

const Error = (/* props */) => <span />;

export default Error;



// WEBPACK FOOTER //
// ./src/components/views/Error.jsx